<template>
  <b-container fluid style="margin-top:90px;">
    <b-card v-if="loading" style="margin-top:90px;" class="text-center">
      <b-spinner label="Loading..."></b-spinner>
    </b-card>

    <b-card v-if="currentStep == 2">
      <b-form @submit="createAssignmentConfirm">
          <b-form-group label="Selected Assignment:">
              <b-form-input type="text" readonly v-model="selectedContent.Title" />
          </b-form-group>
          <b-form-group label="Selected Class:">
              <b-form-input type="text" readonly v-model="currentClass.Name" />
          </b-form-group>
          <div v-if="selectedContent.ContentType == 'BOOK'"> 
            <b-form-group :label="'Start Page: ' + minPage">
                <b-form-input type="range" :min="minPageRange" :max="maxPageRange" v-model="minPage" />
            </b-form-group>
            <b-form-group :label="'End Page: ' + maxPage">
                <b-form-input type="range" :min="minPageRange" :max="maxPageRange" v-model="maxPage" />
            </b-form-group>
          </div>
          <b-form-group label="Due On:">
              <b-form-input type="date" required v-model="dueOn" />
          </b-form-group>
          <b-form-group>
              <b-button type="submit">Create Assignment</b-button>
          </b-form-group>
      </b-form>
    </b-card>

    <b-card v-if="!loading" class="mt-1">
      <h5 v-if="currentStep == 0">Select a piece of content to assign.</h5>
      <b-table striped outlined hover :items="content" :fields="contentFields" @row-clicked="contentClicked" v-if="currentStep == 0">
      </b-table>

      <h5 v-if="currentStep == 1">Select a class.</h5>
      <b-table striped outlined hover :items="classes" :fields="classesFields" @row-clicked="classClicked" v-if="currentStep == 1" id="bookPageTable">
      </b-table>

      <h5 v-if="currentStep == 2">Interactive content included:</h5>
      <b-table striped outlined hover :items="childContent" :fields="childContentFields" v-if="currentStep == 2">
      </b-table>
    </b-card>
  </b-container>
</template>
<script>
import { ajaxGet, ajaxPost } from "../../ajax";
import {apiUrl} from "@/main";


export default {
    data: function() {
    return {
      currentStep: 0,
      currentClass: null,
      selectedContent: -1,
      minPageRange: 1,
      maxPageRange: 1,
      minPage: 1,
      maxPage: 1,
      dueOn: (new Date()).toLocaleDateString(),
      loading: false,
      content: [],
      originalContent: [],
      contentFields: [
        { key:"ID",thClass: 'd-none', tdClass: 'd-none'}, 
        "Title",
        "ContentType"
      ],
      classes: [],
      classesFields: [
        { key:"ID",thClass: 'd-none', tdClass: 'd-none'},
        "Name"
      ],
      childContent: [],
      childContentFields: [
          "Title", {key: "ParentLocation", label: "Page"}, "Component"
      ],
      childCreateRemaining: 0
    };
  },
  watch:{
      maxPage: function(val){
        this.maxPage = val;
        this.childContent = [];

        for(let a = 0; a < this.originalContent.length; a++){
          if(this.originalContent[a].ParentLocation >= this.minPage && this.originalContent[a].ParentLocation <= this.maxPage){
            this.childContent.push(this.originalContent[a]);
          }
        }
      },
    minPage: function(val) {

      this.minPage = val;
      this.childContent = [];
      
      for (let a = 0; a < this.originalContent.length; a++) {
        if (this.originalContent[a].ParentLocation >= this.minPage && this.originalContent[a].ParentLocation <= this.maxPage) {
          this.childContent.push(this.originalContent[a]);
        }
      }
    }
  },
  props: ["token"],
  mounted: function() {
    this.loading = true;

    var caf = this;

    setTimeout(function() {
      ajaxGet(
        apiUrl() +"/content/rootitems",
        caf.dataSuccessLoad,
        caf.dataError,
        caf.token
      );
    }, 50);

    setTimeout(function() {
      ajaxGet(
        apiUrl() + "/classes",
        caf.dataClassesSuccessLoad,
        caf.dataError,
        caf.token
      );
    }, 50);

    //window.alert(this.token);
  },
  methods: {
    dataSuccessLoad: function(res) {
      this.content = res;
      this.loading = false;
    },
    dataClassesSuccessLoad: function(res) {
      this.classes = res;
      this.loading = false;
    },
    dataChildContentSuccessLoad: function(res) {
        res.sort(function(a,b) {
            return a.ParentLocation < b.ParentLocation ? -1 : (a.ParentLocation > b.ParentLocation) ? 1 : 0;
        });
      
      for (let a = 0; a < res.length; a++){
       
        this.originalContent.push(res[a]);
      }
      this.childContent = res;
      this.loading = false;
    },
    dataError: function(status = 0) {
      if (status == 401) {
        this.$emit("logout");
        this.$router.push("/");
      }
    },
    contentClicked(record, index) {
        this.selectedContent = record;
        this.maxPageRange = this.selectedContent.ContentLength;
        this.currentStep = this.currentStep + 1;
    },
    classClicked(record, index) {
        this.currentClass = record;
        this.currentStep = this.currentStep + 1;

        ajaxGet(
            apiUrl() +"/content/" + this.selectedContent.ID + "/children",
            this.dataChildContentSuccessLoad,
            this.dataError,
            this.token
        );
    },
    createAssignmentConfirm(event) {
        event.preventDefault();

        var thisComponent = this;

        this.$bvModal.msgBoxConfirm('Are you sure you want to create this assignment?')
          .then(value => {
            if(value)
                thisComponent.createAssignment();
          })
          .catch(err => {
            // An error occurred
            
          })
    },
    createAssignment() {
        //ajaxPost (url, data, success, error, token = null)
        ajaxPost(
            apiUrl() +"/assignments",
            {
                contentId: this.selectedContent.ID,
                DueOn: this.dueOn,
                classId: this.currentClass.ID,
                parentID: null,
                startPoint: this.minPage - 1,
                endPoint: this.maxPage - 1
            },
            this.rootAssignmentCreated,
            this.dataError,
            this.token
        );
    },
    rootAssignmentCreated(res) {
        this.childContent.forEach(element => {
            if(element.ParentLocation >= (this.minPage-1) && element.ParentLocation <= (this.maxPage-1)) {
                this.childCreateRemaining++;
            }
        });

        //childCreateRemaining
        //res.insertId

        var newAssignmentID = res.insertId;

        this.childContent.forEach(element => {
            if(element.ParentLocation >= (this.minPage-1) && element.ParentLocation <= (this.maxPage-1)) {
                ajaxPost(
                    apiUrl() +"/assignments",
                    {
                        contentId: element.ID,
                        DueOn: this.dueOn,
                        classId: this.currentClass.ID,
                        parentId: newAssignmentID,
                        startPoint: 0,
                        endPoint: 0
                    },
                    this.childAssignmentCreate,
                    this.dataError,
                    this.token
                );
            }
        });
    },
    childAssignmentCreate(res) {
        this.childCreateRemaining--;

        if(this.childCreateRemaining == 0) {
            this.$bvModal.msgBoxOk('Assignment created')
            .then(value => {
                this.$router.push({ path: "/assignments"  });
            })
            .catch(err => {
                // An error occurred
                
            });
        }
    }
  }
}
</script>